import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-input'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import InputColorHex from '@/components/input/InputColorHex.vue'
import FileManagerWithList from '@/components/FileManagerWithList.vue'
import {$} from '@/facade'

export class InputGithubOrganizationSchema extends DefaultSchema {
  readonly name = 'InputGithubOrganization'

  readonly fieldSet: FieldSet<GithubOrganization> = {
    name: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    url: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    location: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    establishedYear: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        pattern: '^[0-9]{4}$',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    colorHex: (schema): FieldComponent => ({
      is: InputColorHex,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    active: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    logoUrl: (): FieldComponent => ({
      is: FileManagerWithList,
      bind: {
        folder: 'organization',
        compressDimension: $.auth.global.dappImageDimension,
        crop: false,
        class: 'scoped__image-url col-span-2',
        required: true,
      },
    }),
  }
}
